import { useMutation, useQueryClient } from "@tanstack/react-query"
import { rejectRfqAdminToSeller, type RejectRfqAdminToSellerPayload } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export interface RejectRfqAdminToSellerVariables {
  id: string
  payload: RejectRfqAdminToSellerPayload
}

export function useRejectRfqAdminToSeller() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: RejectRfqAdminToSellerVariables) =>
      rejectRfqAdminToSeller(id, payload, accessToken!),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["seller-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["admin-seller-rfq-detail", id] })
    },
  })
}
